import { interfaces } from '@daas-consulting/core-cross-interfaces';

export type CriteriaWithoutLabel = Omit<interfaces.Criteria, 'label'>;

interface GetModelFromFilterOptions<TFilter> {
  criterias: CriteriaWithoutLabel[];
  defaultFilter: TFilter;
}

export function getModelFromFilter<TFilter>({
  criterias,
  defaultFilter,
}: GetModelFromFilterOptions<TFilter>): TFilter {
  const rv = { ...defaultFilter };
  const groupedValues = new Map<string, unknown[]>();
  criterias.forEach((criteria) => {
    (
      criteria.attributes ?? [{ key: criteria.key, value: criteria.value }]
    ).forEach((attr) => {
      const values = groupedValues.get(attr.key) ?? [];
      values.push(attr.value);
      groupedValues.set(attr.key, values);
    });
  });

  groupedValues.forEach((values, key) => {
    const typedKey = key as keyof TFilter;
    // Claves repetidas en el query string (?institutionIds=a&institutionIds=b)
    // se agregan como array deduplicado; una sola ocurrencia se mantiene escalar.
    rv[typedKey] = (
      values.length > 1 ? Array.from(new Set(values)) : values[0]
    ) as TFilter[keyof TFilter];
  });

  return rv;
}
